<template>
	<div class="services padding-vertical-2 padding-horizontal-1" :style="{ backgroundImage: `url(${data.thumbnail})` }">
		<div class="grid-x align-center-middle height-100">
			<div class="cell large-8">
				<div class="grid-x grid-margin-x grid-margin-y align-center-middle height-100">
					<div class="cell medium-4" v-for="(page, key) in pages" :key="++key">
						<router-link class="service-card" :to="{ name: 'service', params: { slug: page.slug }}" :style="{ backgroundImage: `url(${page.thumbnail})` }">
							<div class="service-card__content flex-container align-center-middle height-100">
								<h4 class="service-card__title">{{ page.title.rendered }}</h4>
							</div>
						</router-link>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { HTTP } from '../http-common'

	export default {

		data() {
			return {
				data: [],
				pages: [],
			}
		},

		created() {
			this.getHomePageData('inicio');
		},

		methods: {
			getHomePageData(slug) {
				HTTP.get(`pages/?slug=${slug}/`)
					.then( res => {
						this.data = res.data[0];
						this.getPages(res.data[0].id)
					})
			},
			getPages(id) {
				HTTP.get(`pages/?exclude=${id}`)
					.then( res => { this.pages = res.data; })
			},
		}
	}
</script>

<style lang="scss">

	%before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 0;
	}

	.services {
		background-size: cover;
		background-position: center;
		position: relative;
		width: 100%;

		&:before {
			@extend %before;
			background: linear-gradient(45deg, #535353d9, #2D2D2Dd9);
		}

		.grid-x {
			position: relative;
			z-index: 2;

			.cell {
				&:nth-child(1) {
					.service-card {
						&:before {
							background: #A60012cc;
						}
					}
				}
				&:nth-child(2) {
					.service-card {
						&:before {
							background: #A65F00cc;
						}
					}
				}
				&:nth-child(3) {
					.service-card {
						&:before {
							background: #CA9A00cc;
						}
					}
				}
			}
		}
	}

	.service-card {
		max-width: 320px;
		height: 150px;
		margin: 0 auto;
		background-size: cover;
		background-position: center;
		position: relative;
		display: block;

		&:before {
			@extend %before;
		}

		&__content {
			position: relative;
			z-index: 2;
		}

		&__title {
			color: #fff;
		}
	}

	@media screen and (min-width: 640px) {
		.services {
			height: 100%;
		}

		.service-card {
			max-width: initial;
			height: 400px;
		}
	}
</style>
